import { render } from "./unit-template-form-page.vue?vue&type=template&id=4ac81746"
import script from "./unit-template-form-page.vue?vue&type=script&lang=js"
export * from "./unit-template-form-page.vue?vue&type=script&lang=js"

import "./unit-template-form-page.vue?vue&type=style&index=0&id=4ac81746&lang=scss"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__